import { j as s } from "./UnstyledButton-ujNMaBde.js";
import { createContext as o, useContext as r } from "react";
function C(n) {
  const e = o(null);
  return [({ children: t, value: i }) => /* @__PURE__ */ s.jsx(e.Provider, { value: i, children: t }), () => {
    const t = r(e);
    if (t === null)
      throw new Error(n);
    return t;
  }];
}
const c = o({
  dir: "ltr",
  toggleDirection: () => {
  },
  setDirection: () => {
  }
});
function l() {
  return r(c);
}
export {
  C as c,
  l as u
};
